import { render, staticRenderFns } from "./PayerInformationApp.vue?vue&type=template&id=4f5b0fff&scoped=true"
import script from "./PayerInformationApp.vue?vue&type=script&lang=js"
export * from "./PayerInformationApp.vue?vue&type=script&lang=js"
import style0 from "./PayerInformationApp.vue?vue&type=style&index=0&id=4f5b0fff&prod&lang=less&scoped=true"
import style1 from "./PayerInformationApp.vue?vue&type=style&index=1&id=4f5b0fff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5b0fff",
  null
  
)

export default component.exports